import { callGet, callPost, callPutById, callDelete } from "../integrations/calls";


import { REQ } from "../../libs/constants";


export const getAllParty = async(token) => {
    return await callGet(`${REQ.PARTY.GET_ALL_ACCOUNT}`, token)
}

export const createAccount = async (data, token) => {
    return await callPost(REQ.PARTY.ADD_ACCOUNT, data, token);
};


export const updateSingleAccount = async (data, token) => {
    return await callPutById(`${REQ.PARTY.UPDATE_ACCOUNT}/${data.partyId}`, data, token);
};

export const deleteSingleAccount = async (data, token) => {
    return await callDelete(`${REQ.PARTY.DELETE_ACCOUNT}/${data.partyId}`, data, token);
};

export const getSingleParty = async(id, token) => {
    return await callGet(`${REQ.PARTY.GET_SINGLE_ACCOUNT}/${id}`, token)
}